import React from 'react'
import { Snowflake, Flame, Clock } from 'lucide-react'

const STEPS = [
  {
    Icon: Snowflake,
    step: '1',
    title: 'Keep frozen until ready',
    body: 'No prep, no thawing, no planning ahead. Store the pack in your freezer and pull out exactly what you need, when you need it.',
  },
  {
    Icon: Flame,
    step: '2',
    title: 'Air fryer, oven, or deep fryer',
    body: 'Straight from frozen — no marinating, no mess. Cook it the way you like: air fryer, conventional oven, or deep fryer.',
  },
  {
    Icon: Clock,
    step: '3',
    title: '5–18 min — crispy, juicy, served',
    body: '5 minutes in a deep fryer, 8 in an air fryer, or 18 in a conventional oven. Hot, crispy, and juicy — faster than delivery.',
  },
] as const

const FreezerToTable: React.FC = () => {
  return (
    <section className="relative z-10" style={{ backgroundColor: '#0d0d0d' }}>
      <div className="container mx-auto px-6 py-8 max-w-6xl">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold !text-white font-heading">
            Freezer to Table in Minutes
          </h2>
          <p className="mt-4 !text-white/60 font-body max-w-2xl mx-auto">
            Restaurant-quality with zero effort. Three steps from your freezer to a finished plate.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {STEPS.map(({ Icon, step, title, body }) => (
            <div
              key={step}
              className="bg-white/5 border border-white/10 rounded-2xl p-5 md:p-8 text-center flex flex-col items-center"
            >
              <div className="relative mb-5">
                <div className="w-16 h-16 rounded-2xl bg-[#2563EB]/10 border border-[#2563EB]/30 flex items-center justify-center">
                  <Icon className="w-8 h-8" style={{ color: '#2563EB' }} strokeWidth={1.75} />
                </div>
                <span
                  className="absolute -top-2 -right-2 w-7 h-7 rounded-full flex items-center justify-center text-sm font-bold !text-white font-heading"
                  style={{ backgroundColor: '#962831' }}
                >
                  {step}
                </span>
              </div>

              <h3 className="text-xl font-bold !text-white font-heading mb-3">
                {title}
              </h3>
              <p className="!text-white/60 font-body leading-relaxed">
                {body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default FreezerToTable
